var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "120px",
                      },
                    },
                    [
                      _vm.userTypeDic.type == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "归属客户：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  on: { change: _vm.handerSearch },
                                  model: {
                                    value: _vm.listPram.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "customerId", $$v)
                                    },
                                    expression: "listPram.customerId",
                                  },
                                },
                                _vm._l(
                                  _vm.listData.customerList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userTypeDic.type == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "归属小程序：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.listPram.appId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "appId", $$v)
                                    },
                                    expression: "listPram.appId",
                                  },
                                },
                                _vm._l(_vm.appOptions, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "绑定人手机号：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入绑定人手机号",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.listPram.bindPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "bindPhone", $$v)
                              },
                              expression: "listPram.bindPhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡密：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入卡密",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.listPram.secretPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "secretPassword", $$v)
                              },
                              expression: "listPram.secretPassword",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { change: _vm.handleStatusChange },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(
                              _vm.listData.statusList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.status, value: item.id },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单名称" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "订单名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderName", $$v)
                                },
                                expression: "listPram.orderName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目编号" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "项目编号",
                              size: "small",
                              clearable: "",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.projectNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "projectNumber", $$v)
                              },
                              expression: "listPram.projectNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放公司" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择发放公司",
                                size: "small",
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.companyId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "companyId", $$v)
                                },
                                expression: "listPram.companyId",
                              },
                            },
                            _vm._l(_vm.companyOptions, function (company) {
                              return _c("el-option", {
                                key: company.id,
                                attrs: {
                                  label: company.name,
                                  value: company.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              format: "yyyy 年 MM 月 dd 日",
                              "value-format": "yyyy-MM-dd",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handlerGetListData },
                            model: {
                              value: _vm.listPram.dateValueNum,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "dateValueNum", $$v)
                              },
                              expression: "listPram.dateValueNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放项目ID" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "发放项目ID",
                              size: "small",
                              clearable: "",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.sendProjectId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "sendProjectId", $$v)
                              },
                              expression: "listPram.sendProjectId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡密ID" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "卡密ID",
                              size: "small",
                              clearable: "",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.fuCardId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "fuCardId", $$v)
                              },
                              expression: "listPram.fuCardId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发卡类型" } },
                        [
                          _c("SelectCardType", {
                            staticClass: "selWidth",
                            attrs: { cardTypeList: _vm.listData.cardTypeList },
                            on: { selectCardType: _vm.selectCardType },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡密类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.listPram.kamiType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "kamiType", $$v)
                                },
                                expression: "listPram.kamiType",
                              },
                            },
                            _vm._l(_vm.kamiTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:order:customer:search"],
                      expression: "['admin:order:customer:search']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.handelSharchEdit },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:order:customer:add"],
                      expression: "['admin:order:customer:add']",
                    },
                  ],
                  staticClass: "mr20",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateCustomerOrder(0)
                    },
                  },
                },
                [_vm._v("新增订单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:order:customer:download"],
                      expression: "['admin:order:customer:download']",
                    },
                  ],
                  staticClass: "mr20",
                  attrs: { type: "primary", loading: _vm.exportLoading },
                  on: { click: _vm.handleOrderExport },
                },
                [_vm._v("订单导出")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:order:customer:kami:export"],
                      expression: "['admin:order:customer:kami:export']",
                    },
                  ],
                  staticClass: "mr20",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleKMemeitExprot(0)
                    },
                  },
                },
                [_vm._v("卡密详细导出")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.page.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("template", { slot: "empty" }, [
                _c("div", { staticClass: "empty-text" }, [
                  _c("div", [_vm._v("暂无数据")]),
                  _vm._v(" "),
                  _vm.debugInfo
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#999",
                            "margin-top": "10px",
                          },
                        },
                        [_c("pre", [_vm._v(_vm._s(_vm.debugInfo))])]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderId", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderName",
                  label: "订单名称",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type", label: "订单类型", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            _vm.transformState(
                              _vm.customerOrderOptions,
                              scope.row.type,
                              "value"
                            )
                          )
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sendTypeName",
                  label: "发卡类型",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "kamiType",
                  label: "卡密类型",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.kamiType === 1
                          ? _c("span", [_vm._v("卡密绑定")])
                          : scope.row.kamiType === 2
                          ? _c("span", [_vm._v("付款码实体卡")])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "projectNumber",
                  label: "项目编号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyId",
                  label: "发放公司",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getCompanyName(
                                scope.row.companyId,
                                scope.row.companyName
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "innerRemark",
                  label: "内部备注",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "归属客户",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            "【" +
                              (scope.row.customerId || "--") +
                              "】" +
                              (scope.row.customerName || "")
                          )
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "发放小程序",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "订单状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm.getStatusName(scope.row.status)
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.getStatusName(scope.row.status))
                              ),
                            ])
                          : _c("span", [_vm._v(_vm._s(scope.row.status))]),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "面值", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalPrice",
                  label: "总面值",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              !_vm.miniProgramCustomer || _vm.miniProgramCustomerId == 58
                ? _c("el-table-column", {
                    attrs: {
                      prop: "balance",
                      label: "余额",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salesPrice",
                  label: "销售总价",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "quantity",
                  label: "发放数量",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "card", label: "对应卡片", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "关联优惠券包", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.couponPackages &&
                        scope.row.couponPackages.length > 0
                          ? _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.formatCouponPackages(
                                      scope.row.couponPackages
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "generateTime",
                  label: "生成时间",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invalidTime",
                  label: "作废时间",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "230",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:order:customer:detail",
                                  "admin:order:customer:update",
                                ],
                                expression:
                                  "['admin:order:customer:detail','admin:order:customer:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.updateCustomerOrder(
                                  scope.row.orderId
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                [0, 1].includes(scope.row.status)
                                  ? "编辑"
                                  : "查看"
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:delete"],
                                    expression:
                                      "['admin:order:customer:delete']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerDelete(scope.row.orderId)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:kami"],
                                    expression: "['admin:order:customer:kami']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openCamiDetail(scope.row.orderId)
                                  },
                                },
                              },
                              [_vm._v("查看卡密")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:download"],
                                    expression:
                                      "['admin:order:customer:download']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadCami(scope.row.orderId)
                                  },
                                },
                              },
                              [_vm._v("下载卡密")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:customer:send"],
                                expression: "['admin:order:customer:send']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.sendMessage(scope.row.orderId)
                              },
                            },
                          },
                          [_vm._v("卡密短信发送")]
                        ),
                        _vm._v(" "),
                        [1].includes(scope.row.status)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:status"],
                                    expression:
                                      "['admin:order:customer:status']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCustomerState(scope.row)
                                  },
                                },
                              },
                              [_vm._v("制卡")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status != 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:allDelete"],
                                    expression:
                                      "['admin:order:customer:allDelete']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handelPopupModel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("整单作废")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.kamiType == 2
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:order:customer:batchUpdate:kami",
                                    ],
                                    expression:
                                      "['admin:order:customer:batchUpdate:kami']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editKami(scope.row)
                                  },
                                },
                              },
                              [_vm._v("批量更新卡密")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:customer:change:project"],
                                expression:
                                  "['admin:order:customer:change:project']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editProjectInfo(scope.row)
                              },
                            },
                          },
                          [_vm._v("修改项目信息")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.page.total || 0,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("CreateCusomerOrder", {
        ref: "CreateCusomerOrderRef",
        attrs: { cardTypeList: _vm.listData.cardTypeList },
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("NextCustomerorder", {
        ref: "NextCustomerorderRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("ImportMessage", {
        ref: "ImportMessageRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("CamiList", {
        ref: "CamiListRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("ProjectInfoEdit", {
        ref: "ProjectInfoEditRef",
        attrs: { cardTypeList: _vm.listData.cardTypeList },
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量更新卡密",
            visible: _vm.batchUpdateDialog.visible,
            width: "500px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.batchUpdateDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "upload-section" },
            [
              _c(
                "div",
                { staticClass: "upload-header" },
                [
                  _c("span", { staticClass: "upload-title" }, [
                    _vm._v("上传文件："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.downloadTemplate },
                    },
                    [_vm._v("\n\t\t\t\t\t\t下载模板\n\t\t\t\t\t")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: _vm.uploadAction,
                    data: { orderId: _vm.currentOrderId },
                    "on-success": _vm.handleUploadSuccess,
                    "on-error": _vm.handleUploadError,
                    "before-upload": _vm.beforeUpload,
                    headers: _vm.uploadHeaders,
                    "show-file-list": false,
                    accept: ".xlsx,.xls,.csv",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("只能上传.xlsx/.xls/.csv文件，且不超过10MB")]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeBatchUpdateDialog } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }